import type { ReactNode } from 'react'
import React, { Children, cloneElement, isValidElement } from 'react'

export interface AspectBoxProps {
  ratio: `${number}:${number}`
  children: ReactNode
}

export const AspectBox = ({ ratio, children }: AspectBoxProps) => {
  return (
    <>
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...child.props,
            style: {
              ...child.props.style,
              aspectRatio: ratio.split(':').join('/'),
            },
          })
        }
      })}
    </>
  )
}
